// Lead capture storage
const KEY = 'ic_leads';

export function loadLeads() {
  try { const v = localStorage.getItem(KEY); return v ? JSON.parse(v) : []; }
  catch { return []; }
}

export function saveLead(contact) {
  const leads = loadLeads();
  const exists = leads.find(l => l.contact === contact.trim());
  if (exists) return;
  const updated = [...leads, { id: Date.now(), contact: contact.trim(), date: new Date().toLocaleDateString('en-GB'), converted: false }];
  try { localStorage.setItem(KEY, JSON.stringify(updated)); } catch {}
}

export function saveLeads(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {}
}
